import _ from "lodash";
import constant from "./constant";
import utils from "./utils";

const api_requests = {
  order_creation: (data, brand_name) => {
    return utils.request({
      method: "POST",
      url: `store/bop/orders/create`,
      data,
      base_url: constant.BASE_URL.STORE,
      headers: {
        "x-owner-name": encodeURIComponent(brand_name),
      },
    });
  },
  get_orders_list: (params) => {
    return utils.request({
      method: "GET",
      url: `store/bop/orders`,
      params,
      base_url: constant.BASE_URL.STORE,
    });
  },
  get_order_details: (id) => {
    return utils.request({
      method: "GET",
      url: `store/bop/orders/${id}?expand=fulfillment_order`,
      base_url: constant.BASE_URL.STORE,
    });
  },
  get_delivery_charge: (id) => {
    return utils.request({
      method: "GET",
      url: `store/bop/orders/delivery-charge`,
      params: { id },
      base_url: constant.BASE_URL.STORE,
    });
  },
  get_rider_location: (id) => {
    return utils.request({
      method: "GET",
      url: `/store/bop/orders/${id}/fulfillment/tracking`,
      base_url: constant.BASE_URL.STORE,
    });
  },
  get_day_wise_txn_history: (date) => {
    return utils.request({
      method: "GET",
      url: `user/bop/wallet/transactions/${date}`,
      version: 2,
    });
  },
  get_business_details: () => {
    return utils.request({
      method: "GET",
      url: `user/bop/wallet`,
      version: 2,
    });
  },
  login: (data) => {
    return utils.request({
      method: "POST",
      url: `user/auth/login-with-password`,
      data,
    });
  },
  get_quote: (data, params) => {
    return utils.request({
      method: "POST",
      url: `store/bop/orders/fulfillment/quote`,
      base_url: constant.BASE_URL.STORE,
      data,
      params,
    });
  },

  get_smart_allocation_config_business: () => {
    return utils.request({
      method: "GET",
      url: "store/bop/fulfillment/network/smart/allocation/config",
      base_url: constant.BASE_URL.STORE,
    });
  },

  get_smart_allocation_config: () => {
    return utils.request({
      method: "GET",
      url: "store/bop/fulfillment/network/smart/allocation/config/default?order_process_type=1&mini_app_request=true",
      base_url: constant.BASE_URL.STORE,
    });
  },

  order_fullfillment: (data) => {
    return utils.request({
      method: "POST",
      url: "store/bop/orders/fulfill",
      base_url: constant.BASE_URL.STORE,
      data,
    });
  },
  get_all_orders_overview_orders_stats: (params) => {
    return utils.request({
      method: "GET",
      url: `store/bop/orders/stats`,
      base_url: constant.BASE_URL.STORE,
      params,
    });
  },
  create_address: (data) => {
    return utils.request({
      method: "POST",
      url: `user/bop/address`,
      data,
      version: 2,
    });
  },
  cancel_fulfilment_order: (id) => {
    return utils.request({
      method: "POST",
      url: `store/bop/orders/${id}/cancel-order-fulfillment`,
      base_url: constant.BASE_URL.STORE,
    });
  },
  get_common_configs: (business_id) => {
    return utils.request({
      method: "GET",
      url: `user/bop/configs`,
      version: 2,
      headers: {
        "owner-id": business_id,
      },
    });
  },
  get_saved_address: (params) => {
    return utils.request({
      method: "GET",
      url: `user/bop/addresses`,
      params,
      version: 2,
    });
  },
  delete_address: (id) => {
    return utils.request({
      method: "PUT",
      url: `user/bop/address/${id}/unsave`,
    });
  },
  update_address: (id, data) => {
    return utils.request({
      method: "PUT",
      url: `user/address/${id}`,
      data,
    });
  },

  get_business_accounts: () => {
    return utils.request({
      method: "GET",
      url: "user/bop/user-accounts",
    });
  },
  init_wallet_txn: (data) => {
    return utils.request({
      method: "POST",
      url: `user/bop/wallet/recharge/init`,
      data,
      version: 2,
    });
  },

  checkout_wallet_recharge: (txn_id, data) => {
    return utils.request({
      method: "POST",
      url: `user/bop/wallet/recharge/${txn_id}/checkout`,
      data,
      version: 2,
    });
  },

  verify_wallet_recharge: (txn_id, data) => {
    return utils.request({
      method: "POST",
      url: `user/bop/wallet/recharge/${txn_id}/verify`,
      data,
      version: 2,
    });
  },

  get_wallet_payment_methods: (txn_id) => {
    return utils.request({
      method: "GET",
      url: `user/bop/wallet/recharge/${txn_id}/payment-method`,
      version: 2,
    });
  },
  update_address: (id, data) => {
    return utils.request({
      method: "PUT",
      url: `user/address/${id}`,
      data,
    });
  },
  create_ticket: (data) => {
    return utils.request({
      method: "POST",
      url: `store/igm/pidge/ticket`,
      data,
      base_url: constant.BASE_URL.STORE,
    });
  },
  request_otp: (data) => {
    return utils.request({
      url: "/user/auth",
      method: "POST",
      data,
    });
  },
  verify_otp: (data) => {
    return utils.request({
      method: "post",
      url: `user/auth/verify`,
      data: data,
    });
  },
  update_profile: (data, token) => {
    return utils.request({
      method: "put",
      url: `user/bop/profile`,
      data: data,
      token,
    });
  },

  register_business_enquiry: (token, data) => {
    return utils.request({
      method: "POST",
      url: `user/bop/business`,
      data,
      token,
      version: 2,
    });
  },
  paytm_auth_code: (data) => {
    return utils.request({
      method: "POST",
      url: `user/auth/paytm-auth`,
      data,
    });
  },
  save_paytm_brand_data: (data) => {
    return utils.request({
      method: "POST",
      url: `user/auth/paytm/brand`,
      data,
    });
  },
  auth_status: (params) => {
    return utils.request({
      url: "user/auth/status",
      method: "GET",
      params,
    });
  },
  get_igm_tickets: (params) => {
    return utils.request({
      url: "store/IGM/pidge/tickets",
      method: "GET",
      base_url: constant.BASE_URL.STORE,
      params,
    });
  },
  get_pricing: () => {
    return utils.request({
      method: "GET",
      url: `user/bop/pricings`,
      version: 2,
    });
  },
};

export default api_requests;
